import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--navy)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background texture */}
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'radial-gradient(circle at 20% 80%, rgba(230,190,138,0.08) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(230,190,138,0.06) 0%, transparent 50%)',
        pointerEvents: 'none'
      }} />

      <div style={{ width: '100%', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src={logo} alt="Crossman & Walsh" style={{ width: '120px', height: '120px', borderRadius: '8px', marginBottom: '20px' }} />
          <div style={{ color: 'var(--gold)', letterSpacing: '3px', fontSize: '11px', fontWeight: '500', textTransform: 'uppercase', marginBottom: '4px' }}>
            Crossman & Walsh
          </div>
          <div style={{ color: 'rgba(230,190,138,0.5)', fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: '16px' }}>
            Staff Portal
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(230,190,138,0.2)',
          borderRadius: '8px',
          padding: '36px'
        }}>
          <h2 style={{ color: 'var(--white)', fontFamily: 'Cormorant Garamond, serif', fontSize: '26px', fontWeight: '400', marginBottom: '28px', textAlign: 'center' }}>
            Sign In
          </h2>

          {error && (
            <div style={{ background: 'rgba(155,58,58,0.15)', border: '1px solid rgba(155,58,58,0.3)', color: '#e08080', padding: '12px 16px', borderRadius: '4px', fontSize: '13px', marginBottom: '20px' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={{ display: 'block', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(230,190,138,0.6)', fontWeight: '500', marginBottom: '8px' }}>
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={{
                  width: '100%', padding: '12px 14px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(230,190,138,0.2)',
                  borderRadius: '4px', color: 'var(--white)',
                  fontFamily: 'Jost, sans-serif', fontSize: '14px'
                }}
              />
            </div>

            <div className="form-group">
              <label style={{ display: 'block', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(230,190,138,0.6)', fontWeight: '500', marginBottom: '8px' }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{
                  width: '100%', padding: '12px 14px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(230,190,138,0.2)',
                  borderRadius: '4px', color: 'var(--white)',
                  fontFamily: 'Jost, sans-serif', fontSize: '14px'
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '13px',
                background: 'var(--gold)', color: 'var(--navy)',
                border: 'none', borderRadius: '4px',
                fontFamily: 'Jost, sans-serif', fontSize: '12px',
                fontWeight: '600', letterSpacing: '2px',
                textTransform: 'uppercase', cursor: 'pointer',
                marginTop: '8px', opacity: loading ? 0.7 : 1,
                transition: 'all 0.2s'
              }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: '20px', marginBottom: 0 }}>
            <Link to="/forgot-password" style={{ color: 'rgba(230,190,138,0.7)', fontSize: '12px', letterSpacing: '1px', textDecoration: 'none' }}>
              Forgot your password?
            </Link>
          </p>
        </div>

        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.2)', fontSize: '11px', marginTop: '24px', letterSpacing: '0.5px' }}>
          Crossman & Walsh Luxury Homes Ltd
        </p>
      </div>
    </div>
  );
};

export default Login;
